import './main.css';
import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useOutletContext } from 'react-router-dom';

const Main = () => {
  const navigate = useNavigate();
  const [setBreadcrumb, setBreadcrumbLink] = useOutletContext();
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    setBreadcrumb(['Dashboard']);
    setBreadcrumbLink(['/dashboard/']);
  }, [setBreadcrumb, setBreadcrumbLink]);

  const apps = [
    { name: 'File Manager', icon: 'file-manager.svg', link: 'https://files.webhizzy.in/', target: '_blank' },
    { name: 'phpMyAdmin', icon: 'phpmyadmin.svg', link: 'https://db.webhizzy.in/', target: '_blank' },
    { name: 'Business Email', icon: 'mail.svg', link: 'https://mail.webhizzy.in/', target: '_blank' },
    { name: 'Mail Admin', icon: 'mail-admin.svg', link: 'https://mailadmin.webhizzy.in/', target: '_blank' },
    { name: 'Marketing CRM', icon: 'marketing.svg', link: '/Marketing', target: '' },
    { name: 'Countdown Timer', icon: 'timer.svg', link: 'https://webhizzy.in/pricing.html?category=maketing-solutions', target: '_blank' },
    { name: 'Support', icon: 'support.svg', link: 'https://webhizzy.in/contact.html', target: '_blank' },
    { name: 'Billing', icon: 'billing.svg', link: 'https://payments.webhizzy.in/', target: '_blank' },
  ];

  const filteredApps = apps.filter(app =>
    app.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <main className="flex-1 px-4 md:px-8 py-8">
      {/* <h1 className="text-3xl font-bold text-center mb-6">Welcome</h1> */}
      <div className="flex justify-center mb-10">
        <div className="relative w-full max-w-xl">
          <input
            type="text"
            placeholder="Search your app"
            className="w-full pl-4 pr-10 py-2 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-400"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <span className="material-icons absolute right-3 top-2 text-gray-400">search</span>
        </div>
      </div>

      {/* Filtered Apps Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 sm:gap-10 mb-8 sm:px-6">
        {filteredApps.map((app, index) => (
          <Link
            target={app.target}
            to={app.link}
            key={index}
            className="px-5 py-6 pt-8 bg-white border rounded-lg flex flex-col items-center hover:shadow-md transition-shadow"
          >
            {app.color ? (
              <span className={`material-icons ${app.color} text-6xl`}>{app.icon}</span>
            ) : (
              <img src={'/images/icons/'+app.icon} alt={app.name} className="w-14 h-14" />
            )}
            <span className="mt-4 text-gray-800 font-medium text-center">{app.name}</span>
          </Link>
        ))}
      </div>


      {/* Bottom Links */}
      {/* <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 border-t border-gray-200 pt-6 mb-8">
        <div>
          <h2 className="font-semibold text-inherit text-base mb-2">Your account</h2>
          <ul className="space-y-1 text-sm text-blue-600">
            <li><a href="#" className="hover:underline">Can't access your account?</a></li>
            <li><a href="#" className="hover:underline">Reset password</a></li>
            <li><a href="#" className="hover:underline">Using 2-Step Verification</a></li>
          </ul>
        </div>
        <div>
          <h2 className="font-semibold text-inherit text-base mb-2">Help Communities</h2>
          <ul className="space-y-1 text-sm text-blue-600">
            <li><a href="#" className="hover:underline">Google Product Forums</a></li>
            <li><a href="#" className="hover:underline">Community Guidelines</a></li>
          </ul>
        </div>
        <div>
          <h2 className="font-semibold text-inherit text-base mb-2">Status dashboard</h2>
          <ul className="space-y-1 text-sm text-blue-600">
            <li><a href="#" className="hover:underline">Google Workspace Status</a></li>
            <li><a href="#" className="hover:underline">Google Ads Status</a></li>
          </ul>
        </div>
      </div> */}

    </main>
  );
};

export default Main;
